import {TagModel} from "./tag.model";
import {Type} from "class-transformer";

export class FolderTagModel {
  folderId: number;
  folder: string;
  tagType: string;
  @Type(() => TagModel)
  tags: TagModel[];
}
